import React, { useEffect, useMemo, useState } from "react";
import "./index.scss";
import { getStepInfo } from "./stepInfo";
import StepControls from "../StepControls";
import StepFooter from "./StepFooter";
import RightBarInfo from "./RightBarInfo";
import BottomBarInfo from "./BottomBarInfo";
import GenderSelect from "./GenderSelect";
import FinishStep from "./FinishStep";
import PageSelectProblem from "./PageSelectProblem";
import EducationStep1 from "./EducationStep1";
import EducationStep2 from "./EducationStep2";
import AdentySelect from "./Adenty/AdentySelect";
import AdentySelectTooth from "./Adenty/AdentySelectTooth";
import ProsthesisSelect from "./Adenty/ProsthesisSelect";
import ImplantationSelectTooth from "./Adenty/ImplantationSelectTooth";
import ImplantationSelectFixation from "./Adenty/ImplantationSelectFixation";
import ImplantationSelectFalseTeeth from "./Adenty/ImplantationSelectFalseTeeth";
import ImplantationSelectFalseTeethConnections from "./Adenty/ImplantationSelectFalseTeethConnections";
import AdentyFullType from "./Adenty/AdentyFullType";
import AdentyFullTypeImplants from "./Adenty/AdentyFullTypeImplants";
import AdentyFullTypeImplantsFixation from "./Adenty/AdentyFullTypeImplantsFixation";
import RemovableProstheticsSelect from "./Adenty/RemovableProstheticsSelect";
import RemovableProstheticsSelectSide from "./Adenty/RemovableProstheticsSelectSide";
import RemovableProstheticsSelectTooth from "./Adenty/RemovableProstheticsSelectTooth";
import FixedProstheticsSelectAbutmentTooth from "./Adenty/FixedProstheticsSelectAbutmentTooth";
import FixedProstheticsSelectSuspendedTooth from "./Adenty/FixedProstheticsSelectSuspendedTooth";
import FixedProstheticsSelectToothConnections from "./Adenty/FixedProstheticsSelectToothConnections";
import ExtraCrownsSelect from "./Adenty/ExtraCrownsSelect";
import ExtraVeneersSelect from "./Adenty/ExtraVeneersSelect";
import AdentySelectDecayedTooth from "./Adenty/AdentySelectDecayedTooth";
import AdentyProstheticsPrepare from "./Adenty/AdentyProstheticsPrepare";
import CompositeRestorationsSelect from "./Adenty/CompositeRestorationsSelect";
import EsteticSelect from "./Estetic/EsteticSelect";
import EsteticSelectVeneers from "./Estetic/EsteticSelectVeneers";
import EsteticSelectCrowns from "./Estetic/EsteticSelectCrowns";
import EsteticSelectRestorations from "./Estetic/EsteticSelectRestorations";
import EsteticTypicalSelect from "./Estetic/EsteticTypicalSelect";
import EsteticTypicalSelectRestorations from "./Estetic/EsteticTypicalSelectRestorations";
import SmileSelect from "./Estetic/SmileSelect";
import OrthodonticSelect from "./Orthodontics/OrthodonticSelect";
import OrthodonticAnomalies from "./Orthodontics/OrthodonticAnomalies";
import OrthodonticTreatment from "./Orthodontics/OrthodonticTreatment";
import OrthoChildTreatment from "./Orthodontics/OrthoChildTreatment";
import OrthoBasicTreatment from "./Orthodontics/OrthoBasicTreatment";
import BRLowSinus from "./BoneRepair/BRLowSinus";
import BRSinusLifting from "./BoneRepair/BRSinusLifting";
import BRBoneAugmentation from "./BoneRepair/BRBoneAugmentation";
import TherapySelectTooth from "./Therapy/TherapySelectTooth";
import ToothDetailing from "./Therapy/ToothDetailing";
import RootDetailing from "./Therapy/RootDetailing";
import ClinicalView from "./Therapy/ClinicalView";
import AutoTreatment from "./Therapy/AutoTreatment";
import TreatmentView from "./Therapy/TreatmentView";
import RestorationSelect from "./Therapy/RestorationSelect";
import RestorationDetailing from "./Therapy/RestorationDetailing";
import CanalFilling from "./Therapy/CanalFilling";
import { StepContext } from "./StepContext";
import { TranslateProvider, useTranslation } from "../i18n"; // Here we can jump over steps

export const patientJumpedSteps = ["PSP_ET_e1_e2_adenty_partial_decayedTeeth", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations_toothConnections", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect_compositeRestorations", "PSP_TM_e1_e2_therapySelect_toothDetailing", "PSP_TM_e1_e2_therapySelect_toothDetailing_rootDetailing"];

const StepsCore = ({
  langCode = "en",
  stepFlow = [{
    id: "PSP",
    formula: {}
  }],
  setStepFlow = () => {},
  formulaBeforeTreatment = null,
  setFormulaBeforeTreatment = () => {},
  formulaType = "",
  setFormulaType = () => {},
  userRole = "patient",
  patientGender = null,
  setPatientGender = () => {},
  patientFace = "face10",
  setPatientFace = () => {},
  openPhotoViewer = () => {},
  openVideoViewer = () => {},
  openVRSlider = () => {},
  openVRViewer = () => {},
  openMediaLibrary = () => {},
  navigate = () => {},
  onSave = () => {}
}) => {
  const {
    language,
    setLanguage
  } = useTranslation();
  useEffect(() => {
    setLanguage(langCode);
  }, [langCode, setLanguage]);

  function addStepChoice(stepId, choice, formula = null) {
    let choicesList = [...stepFlow];
    let availableFormulas = choicesList.filter(el => el.formula);
    let lastAvailable = availableFormulas[availableFormulas.length - 1]; // if in props = rewrite from props, if no - use last available

    let formulaForInsert = null;

    if (formula) {
      formulaForInsert = formula;
    } else if (lastAvailable) {
      formulaForInsert = lastAvailable.formula;
    }

    const stepForInsert = `${stepId}_${choice}`;
    choicesList.push({
      id: stepForInsert,
      formula: formulaForInsert
    });
    setStepFlow(choicesList);

    if (userRole === "patient") {
      switch (stepForInsert) {
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth":
          addStepChoice(stepForInsert, "prostheticsPrepare");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare":
          addStepChoice(stepForInsert, "prosthesisSelect");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect":
          addStepChoice(stepForInsert, "extraVeneersSelect");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect":
          addStepChoice(stepForInsert, "compositeRestorations");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations":
          addStepChoice(stepForInsert, "toothConnections");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations_toothConnections":
          addStepChoice(stepForInsert, "finishStep");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect":
          addStepChoice(stepForInsert, "extraVeneersSelect");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect":
          addStepChoice(stepForInsert, "compositeRestorations");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations":
          addStepChoice(stepForInsert, "implantationSelectFalseTeethConnection");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection":
          addStepChoice(stepForInsert, "finishStep");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect":
          addStepChoice(stepForInsert, "compositeRestorations");
          break;

        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect_compositeRestorations":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect_compositeRestorations":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect_compositeRestorations":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect_compositeRestorations":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect_compositeRestorations":
        case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect_compositeRestorations":
          addStepChoice(stepForInsert, "finishStep");
          break;

        case "PSP_TM_e1_e2_therapySelect_toothDetailing":
          addStepChoice(stepForInsert, "rootDetailing");
          break;

        case "PSP_TM_e1_e2_therapySelect_toothDetailing_rootDetailing":
          addStepChoice(stepForInsert, "clinicalView");
          break;

        default:
          console.log("stepForInsert", stepForInsert);
      }
    }
  }

  function removeStepChoice() {
    let choicesList = [...stepFlow];

    if (choicesList.length > 1) {
      choicesList.pop();
    }

    setStepFlow(choicesList);

    if (userRole === "patient") {
      const nextPreviousStep = choicesList[choicesList.length - 1].id;

      if (patientJumpedSteps.includes(nextPreviousStep)) {
        removeStepChoice();
      }
    }
  }

  function rewriteCurrentStep(stepId, newStepId) {
    let choicesList = [...stepFlow];
    choicesList = choicesList.map(el => {
      if (el.id === stepId) {
        return { ...el,
          id: newStepId
        };
      }

      return el;
    });
    setStepFlow(choicesList);
  }

  function setStepFormula(stepId, data) {
    let choicesList = [...stepFlow];
    choicesList = choicesList.map(el => {
      if (el.id === stepId) {
        let formula = el.formula ? { ...el.formula
        } : {};
        return { ...el,
          formula: { ...formula,
            ...data
          }
        };
      }

      return el;
    });
    setStepFlow(choicesList);
  }

  function resetStep() {
    setStepFlow([{
      id: "PSP",
      formula: {}
    }]);
    setFormulaBeforeTreatment(null);
    setFormulaType("");
    setPatientFace("face10");
    setPatientGender(null);
  }

  function goToStep(stepId) {
    let choicesList = [...stepFlow];

    for (let i = choicesList.length - 1; i >= 0; i--) {
      if (choicesList[i].id === stepId) break;
      choicesList.pop();
    }

    setStepFlow(choicesList);
  }

  const currentChoice = stepFlow[stepFlow.length - 1];
  const stepId = currentChoice.id;
  const stepInfo = getStepInfo(language, stepId, userRole);
  const [stepInfoPostfix, setStepInfoPostfix] = useState("");
  const [stepInfoPrefix, setStepInfoPrefix] = useState("");
  const [isNextBtnDisabled, setIsNextBtnDisabled] = useState(false);

  function toggleNextBtnState(type) {
    setIsNextBtnDisabled(type);
  }

  function setPrevStep() {
    setIsNextBtnDisabled(false);

    if (currentChoice.id === "PSP_lowSinus") {
      resetStep();

      if (navigate && userRole === "doctor") {
        navigate("/admin");
      }
    } else {
      removeStepChoice();
    }
  }

  function selectStep(choice, formula = null) {
    if (choice === "rewrite") {
      let rewriteChoice = getStepInfo(language, currentChoice.id).rewriteKey;
      rewriteCurrentStep(currentChoice.id, rewriteChoice);
    } else {
      addStepChoice(currentChoice.id, choice, formula);
    }
  }

  const [tmpPreChoice, setTmpPreChoice] = useState(null);

  function onProblemSelect(preChoice) {
    if (!patientGender) {
      setTmpPreChoice(preChoice);
      setGenderSelect(true);
    } else {
      pspSelect(preChoice);
    }
  }

  const [isGenderSelect, setGenderSelect] = useState(false);

  function selectGender(gender) {
    setPatientGender(gender);
    setPatientFace("face10");
    setGenderSelect(false);
    pspSelect(tmpPreChoice);
  }

  function pspSelect(preChoice) {
    let step = `${preChoice}_e1`;

    if (userRole !== "patient") {
      step = getOverStep(`${preChoice}_e1_e2`);
    }

    if (preChoice === "OM" || preChoice === "TM") {
      step = getOverStep(`${preChoice}_e1_e2`);
    }

    selectStep(step);
  } // Reset postfix on any change with steps


  useEffect(() => {
    setNextKeyPostfix("");
  }, [stepId]); // Reset prefix on any change with steps

  useEffect(() => {
    setNextKeyPrefix("");
  }, [stepId]);

  function setNextKeyPostfix(postfix = "") {
    setStepInfoPostfix(postfix);
  }

  function setNextKeyPrefix(prefix = "") {
    setStepInfoPrefix(prefix);
  } // Used for additional manipulation from components on next keys


  const stepInfoNextKey = stepInfo.hasOwnProperty("nextKey") ? stepInfo.nextKey : "";
  const stepNextKey = `${stepInfoPrefix ? `${stepInfoPrefix}_` : ""}${stepInfoNextKey}${stepInfoPostfix ? `_${stepInfoPostfix}` : ""}`; // const stepNextKey = stepInfoPostfix ? stepInfoNextKey + "_" + stepInfoPostfix : stepInfoNextKey;

  const stepNextTitle = stepInfo.nextTitle;
  const stepTitle = stepInfo.title;
  const stepIcon = stepInfo?.icon;
  const stepSubTitle = stepInfo.subTitle;
  const stepSubTitleIcon = stepInfo.hasOwnProperty("subTitleIcon") ? stepInfo.subTitleIcon : null;
  const isBackBtnDisabled = useMemo(() => stepId === "PSP", [stepId]); // For skip education

  function getOverStep(step) {
    const currentStepId = `${currentChoice.id}_${step}`;
    const nextStepId = getStepInfo(language, currentStepId).nextKey;
    return `${step}_${nextStepId}`;
  }

  const [isRightBarInfo, setIsRightBarInfo] = useState(false);
  const [rightBarInfoKey, setRightBarInfoKey] = useState(null);
  const [isBottomBarInfo, setIsBottomBarInfo] = useState(false);
  const [bottomBarInfoKey, setBottomBarInfoKey] = useState(null);

  function toggleBottomBarInfo(status, key) {
    setIsBottomBarInfo(status);
    setBottomBarInfoKey(key);
  }

  function toggleRightBarInfo(status, key) {
    setIsRightBarInfo(status);
    setRightBarInfoKey(key);
  }

  const isPatient = userRole === "patient";
  return /*#__PURE__*/React.createElement(StepContext.Provider, {
    value: {
      isPatient: isPatient,
      dentalData: stepFlow.find(el => el.id === stepId).formula,
      setStepFormula: setStepFormula,
      beforeTreatmentFormula: formulaBeforeTreatment,
      setFormulaBeforeTreatment: setFormulaBeforeTreatment,
      patientGender: patientGender,
      patientFace: patientFace,
      setPatientFace: setPatientFace,
      formulaType: formulaType,
      goToStep: goToStep,
      toggleBottomBarInfo: toggleBottomBarInfo,
      toggleRightBarInfo: toggleRightBarInfo,
      openVRSlider: openVRSlider,
      openVideoViewer: openVideoViewer
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "stepsCore"
  }, /*#__PURE__*/React.createElement(StepControls, {
    title: stepTitle,
    icon: stepIcon,
    subTitle: stepSubTitle,
    subTitleIcon: stepSubTitleIcon,
    nextKey: stepNextKey,
    nextTitle: stepNextTitle,
    goBack: setPrevStep,
    goForward: selectStep,
    isNextBtnDisabled: isNextBtnDisabled,
    isBackBtnDisabled: isBackBtnDisabled,
    onSave: onSave
  }), /*#__PURE__*/React.createElement("div", {
    className: "stepsCore-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "stepsCore-view"
  }, stepId === "PSP" && /*#__PURE__*/React.createElement(PageSelectProblem, {
    selectStep: onProblemSelect
  }), ["PSP_ET_e1", "PSP_EM_e1", "PSP_OM_e1", "PSP_TM_e1"].includes(stepId) && /*#__PURE__*/React.createElement(EducationStep1, {
    stepId: stepId
  }), ["PSP_ET_e1_e2", "PSP_EM_e1_e2", "PSP_OM_e1_e2", "PSP_TM_e1_e2"].includes(stepId) && /*#__PURE__*/React.createElement(EducationStep2, {
    stepId: stepId
  }), stepId === "PSP_ET_e1_e2_adenty" && /*#__PURE__*/React.createElement(AdentySelect, {
    selectStep: selectStep
  }), stepId === "PSP_ET_e1_e2_adenty_partial" && /*#__PURE__*/React.createElement(AdentySelectTooth, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), stepId === "PSP_ET_e1_e2_adenty_partial_decayedTeeth" && /*#__PURE__*/React.createElement(AdentySelectDecayedTooth, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), stepId === "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare" && /*#__PURE__*/React.createElement(AdentyProstheticsPrepare, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), stepId === "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect" && /*#__PURE__*/React.createElement(ProsthesisSelect, {
    selectStep: selectStep,
    stepId: stepId
  }), stepId === "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation" && /*#__PURE__*/React.createElement(ImplantationSelectTooth, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), stepId === "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation" && /*#__PURE__*/React.createElement(ImplantationSelectFixation, {
    selectStep: selectStep,
    stepId: stepId
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation"].includes(stepId) && /*#__PURE__*/React.createElement(ImplantationSelectFalseTeeth, {
    selectStep: selectStep,
    stepId: stepId
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect"].includes(stepId) && /*#__PURE__*/React.createElement(ExtraCrownsSelect, {
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect"].includes(stepId) && /*#__PURE__*/React.createElement(ExtraVeneersSelect, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection"].includes(stepId) && /*#__PURE__*/React.createElement(ImplantationSelectFalseTeethConnections, {
    selectStep: selectStep,
    stepId: stepId
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics"].includes(stepId) && /*#__PURE__*/React.createElement(FixedProstheticsSelectAbutmentTooth, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect"].includes(stepId) && /*#__PURE__*/React.createElement(FixedProstheticsSelectSuspendedTooth, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect"].includes(stepId) && /*#__PURE__*/React.createElement(ExtraCrownsSelect, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect"].includes(stepId) && /*#__PURE__*/React.createElement(ExtraVeneersSelect, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations_toothConnections"].includes(stepId) && /*#__PURE__*/React.createElement(FixedProstheticsSelectToothConnections, {
    selectStep: selectStep,
    stepId: stepId
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics"].includes(stepId) && /*#__PURE__*/React.createElement(RemovableProstheticsSelect, {
    selectStep: selectStep
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase"].includes(stepId) && /*#__PURE__*/React.createElement(RemovableProstheticsSelectSide, {
    selectStep: selectStep,
    stepId: stepId
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth"].includes(stepId) && /*#__PURE__*/React.createElement(RemovableProstheticsSelectTooth, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect"].includes(stepId) && /*#__PURE__*/React.createElement(ExtraCrownsSelect, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect_compositeRestorations", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect_compositeRestorations"].includes(stepId) && /*#__PURE__*/React.createElement(CompositeRestorationsSelect, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_adentyTop", "PSP_ET_e1_e2_adenty_adentyBottom", "PSP_ET_e1_e2_adenty_adentyBoth"].includes(stepId) && /*#__PURE__*/React.createElement(AdentyFullType, {
    selectStep: selectStep,
    stepId: stepId
  }), ["PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant"].includes(stepId) && /*#__PURE__*/React.createElement(AdentyFullTypeImplants, {
    stepId: stepId,
    stepInfoPostfix: stepInfoPostfix,
    setNextKey: setNextKeyPostfix,
    currentChoice: currentChoice,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4", "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6"].includes(stepId) && /*#__PURE__*/React.createElement(AdentyFullTypeImplantsFixation, {
    selectStep: selectStep,
    stepId: stepId
  }), "PSP_EM_e1_e2_estetic" === stepId && /*#__PURE__*/React.createElement(EsteticSelect, {
    selectStep: selectStep,
    stepId: stepId
  }), "PSP_EM_e1_e2_estetic_esCustomVeneers" === stepId && /*#__PURE__*/React.createElement(EsteticSelectVeneers, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), "PSP_EM_e1_e2_estetic_esCustomVeneers_esCustomCrowns" === stepId && /*#__PURE__*/React.createElement(EsteticSelectCrowns, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), "PSP_EM_e1_e2_estetic_esCustomVeneers_esCustomCrowns_esCustomRestorations" === stepId && /*#__PURE__*/React.createElement(EsteticSelectRestorations, {
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), "PSP_EM_e1_e2_estetic_esCustomVeneers_esCustomCrowns_esCustomRestorations_smileSelect" === stepId && /*#__PURE__*/React.createElement(SmileSelect, null), "PSP_EM_e1_e2_estetic_esTypicalSelect" === stepId && /*#__PURE__*/React.createElement(EsteticTypicalSelect, {
    selectStep: selectStep
  }), ["PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom"].includes(stepId) && /*#__PURE__*/React.createElement(EsteticTypicalSelectRestorations, {
    selectStep: selectStep
  }), ["PSP_OM_e1_e2_orthodonticSelect"].includes(stepId) && /*#__PURE__*/React.createElement(OrthodonticSelect, {
    selectStep: selectStep
  }), ["PSP_OM_e1_e2_orthodonticSelect_orthodonticAnomalies"].includes(stepId) && /*#__PURE__*/React.createElement(OrthodonticAnomalies, null), ["PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment"].includes(stepId) && /*#__PURE__*/React.createElement(OrthodonticTreatment, {
    selectStep: selectStep
  }), ["PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoChildTreatment"].includes(stepId) && /*#__PURE__*/React.createElement(OrthoChildTreatment, {
    stepId: stepId,
    stepInfoPrefix: stepInfoPrefix,
    setNextKeyPrefix: setNextKeyPrefix,
    currentChoice: currentChoice,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoBasicTreatment"].includes(stepId) && /*#__PURE__*/React.createElement(OrthoBasicTreatment, {
    stepId: stepId
  }), ["PSP_lowSinus"].includes(stepId) && /*#__PURE__*/React.createElement(BRLowSinus, {
    stepId: stepId,
    stepInfoPrefix: stepInfoPrefix,
    setNextKeyPrefix: setNextKeyPrefix,
    currentChoice: currentChoice,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_lowSinus_sinusLifting"].includes(stepId) && /*#__PURE__*/React.createElement(BRSinusLifting, {
    stepId: stepId,
    stepInfoPrefix: stepInfoPrefix,
    setNextKeyPrefix: setNextKeyPrefix,
    currentChoice: currentChoice,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_lowSinus_sinusLifting_boneAugmentation"].includes(stepId) && /*#__PURE__*/React.createElement(BRBoneAugmentation, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_TM_e1_e2_therapySelect"].includes(stepId) && /*#__PURE__*/React.createElement(TherapySelectTooth, {
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_TM_e1_e2_therapySelect_toothDetailing"].includes(stepId) && /*#__PURE__*/React.createElement(ToothDetailing, {
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_TM_e1_e2_therapySelect_toothDetailing_rootDetailing"].includes(stepId) && /*#__PURE__*/React.createElement(RootDetailing, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_TM_e1_e2_therapySelect_toothDetailing_rootDetailing_clinicalView"].includes(stepId) && /*#__PURE__*/React.createElement(ClinicalView, {
    stepId: stepId
  }), ["PSP_TM_e1_e2_therapySelect_toothDetailing_rootDetailing_clinicalView_autoTreatment"].includes(stepId) && /*#__PURE__*/React.createElement(AutoTreatment, {
    stepId: stepId
  }), ["PSP_TM_e1_e2_therapySelect_toothDetailing_rootDetailing_clinicalView_autoTreatment_treatmentView"].includes(stepId) && /*#__PURE__*/React.createElement(TreatmentView, {
    selectStep: selectStep,
    stepId: stepId
  }), ["PSP_TM_e1_e2_therapySelect_toothDetailing_rootDetailing_clinicalView_autoTreatment_treatmentView_restorationSelect"].includes(stepId) && /*#__PURE__*/React.createElement(RestorationSelect, {
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_TM_e1_e2_therapySelect_toothDetailing_rootDetailing_clinicalView_autoTreatment_treatmentView_restorationSelect_restorationDetailing"].includes(stepId) && /*#__PURE__*/React.createElement(RestorationDetailing, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_TM_e1_e2_therapySelect_toothDetailing_rootDetailing_clinicalView_autoTreatment_treatmentView_restorationSelect_restorationDetailing_canalFilling"].includes(stepId) && /*#__PURE__*/React.createElement(CanalFilling, {
    selectStep: selectStep,
    stepId: stepId,
    toggleNextBtnState: toggleNextBtnState
  }), ["PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection_finishStep", "PSP_ET_e1_e2_adenty_adentyTop_adentyTopGum", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomGum", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothGum", "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4_cementImplantProsthesisFixationTop4", "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6_cementImplantProsthesisFixationTop6", "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4_multiunitImplantProsthesisFixationTop4", "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6_multiunitImplantProsthesisFixationTop6", "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4_telescopImplantProsthesisFixationTop4", "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6_telescopImplantProsthesisFixationTop6", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4_cementImplantProsthesisFixationBottom4", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6_cementImplantProsthesisFixationBottom6", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4_multiunitImplantProsthesisFixationBottom4", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6_multiunitImplantProsthesisFixationBottom6", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4_telescopImplantProsthesisFixationBottom4", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6_telescopImplantProsthesisFixationBottom6", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4_cementImplantProsthesisFixationBoth4", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6_cementImplantProsthesisFixationBoth6", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4_multiunitImplantProsthesisFixationBoth4", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6_multiunitImplantProsthesisFixationBoth6", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4_telescopImplantProsthesisFixationBoth4", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6_telescopImplantProsthesisFixationBoth6", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations_toothConnections_finishStep", "PSP_EM_e1_e2_estetic_esCustomVeneers_esCustomCrowns_esCustomRestorations_smileSelect_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalVeneers_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalVeneers_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalVeneers_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalVeneers_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalCrowns_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalCrowns_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalCrowns_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalCrowns_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalRestorations_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalRestorations_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalRestorations_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalRestorations_finishStep", "PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoBasicTreatment_finishStep", "PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoChildTreatment_singleJawApparate_finishStep", "PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoChildTreatment_doubleJawApparate_finishStep", "PSP_lowSinus_sinusLifting_boneAugmentation_finishStep", "PSP_TM_e1_e2_therapySelect_toothDetailing_rootDetailing_clinicalView_autoTreatment_treatmentView_restorationSelect_restorationDetailing_canalFilling_finishStep"].includes(stepId) && /*#__PURE__*/React.createElement(FinishStep, {
    stepId: stepId
  }))), /*#__PURE__*/React.createElement(StepFooter, {
    stepInfo: stepInfo
  }), /*#__PURE__*/React.createElement(GenderSelect, {
    isShow: isGenderSelect,
    onSelect: selectGender,
    onClose: () => {
      setGenderSelect(false);
    }
  }), /*#__PURE__*/React.createElement(RightBarInfo, {
    isOpen: isRightBarInfo,
    infoKey: rightBarInfoKey,
    onClose: () => {
      toggleRightBarInfo(false, null);
    },
    openPhotoViewer: openPhotoViewer,
    openVideoViewer: openVideoViewer,
    openVRViewer: openVRViewer,
    openMediaLibrary: openMediaLibrary
  }), /*#__PURE__*/React.createElement(BottomBarInfo, {
    isOpen: isBottomBarInfo,
    infoKey: bottomBarInfoKey,
    stepId: stepId,
    onClose: () => {
      toggleBottomBarInfo(false, null);
    },
    goToStep: goToStep,
    openPhotoViewer: openPhotoViewer,
    openVideoViewer: openVideoViewer,
    openVRViewer: openVRViewer,
    openMediaLibrary: openMediaLibrary
  })));
};

const StepsCoreWrapper = props => {
  return /*#__PURE__*/React.createElement(TranslateProvider, null, /*#__PURE__*/React.createElement(StepsCore, props));
};

export default StepsCoreWrapper;